import './LoadingSpinner.css'

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  className?: string
  label?: string
}

function LoadingSpinner({
  size = 'medium',
  className = '',
  label = 'Loading'
}: LoadingSpinnerProps) {
  const sizeClass = `loading-spinner--${size}`

  return (
    <div
      className={`loading-spinner ${sizeClass} ${className}`}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="loading-spinner__circle" aria-hidden="true">
        <svg viewBox="0 0 50 50">
          <circle
            className="loading-spinner__path"
            cx="25"
            cy="25"
            r="20"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <span className="loading-spinner__label">{label}</span>
    </div>
  )
}

export default LoadingSpinner